import React, {useEffect, useState} from 'react';
import {requestGetDVTJCUVPipeLineList} from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import DVTJCUVPipelineTableList, {DVTJCUVPipelineListMode} from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import Button from "react-bootstrap/Button";
import {
    DVTJCUVSearchCddJobParentTabs,
    DVTJCUVSearchCddJobSetReceiverListTabs
} from "@pages/dvtjcuv/common/SearchCddJobTabs";
import DVTJCUVSearchCddJobChooseReceiverModal
    from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobChooseReceiverModal";
import DVTJCUVPipelineGroupByCddEmpFuNeededAndProcessList
    from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVPipelineGroupByCddEmpFuNeededAndProcessList";

const DVTJCUVHaveJobTabContent = (props) => {
    // const [pipelineList, setPipelineList] = useState([]);

    const [parentOfTab, setParentOfTab] = useState({});
    const [currentTab, setCurrentTab] = useState({});

    const {cddId, parentTab, subTab} = props

    // const fetchPipeLines = async (pTab, sTab, sorts) => {
    //     const params = {
    //         search_conditions: {
    //             parent_tab: pTab?.id,
    //             sub_tab: sTab?.id,
    //             cdd_id: cddId,
    //             unlimited: true
    //         },
    //         sort_columns: sorts
    //     }
    //
    //     const res = await requestGetDVTJCUVPipeLineList(params);
    //     const resContent = res.content
    //     setPipelineList(resContent.pipelines)
    //
    // }

    useEffect(() => {
        setParentOfTab(parentOfTab)
        setCurrentTab(subTab)
    }, [parentTab, subTab]);

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>{subTab.title}</h3>
                    <div className={'card-tools'}>
                        {/*<div className={'row'}>*/}
                        {/*    <Button className={'btn btn-default mr-3'} onClick={() => {}}>*/}
                        {/*        Source more Receivers*/}
                        {/*    </Button>*/}
                        {/*    <Button className={'btn btn-default mr-3'}*/}
                        {/*            onClick={() => setShowChooseReceiverModal(true)}>*/}
                        {/*        Copy List Receivers*/}
                        {/*    </Button>*/}
                        {/*</div>*/}
                    </div>
                </div>
                <div className='card-body'>
                    {/*<DVTJCUVPipelineTableList*/}
                    {/*    pipeLines={pipelineList}*/}
                    {/*    mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD}*/}
                    {/*    parentTabId={DVTJCUVSearchCddJobParentTabs.HAVE_JOB_TAB.id}*/}
                    {/*    subTabId={subTab.id}*/}
                    {/*/>*/}
                    <DVTJCUVPipelineGroupByCddEmpFuNeededAndProcessList
                        cddId={cddId}
                        mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD}
                        parentTab={DVTJCUVSearchCddJobParentTabs.HAVE_JOB_TAB}
                        subTab={currentTab}
                        startFetching={!!currentTab.id}
                    />
                </div>
            </div>
        </>
    )
}
export default DVTJCUVHaveJobTabContent;
